import * as React from "react";
import * as ReactDOM from "react-dom";
import { ScrollBarVisibility } from "./";

interface IProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children: JSX.Element | JSX.Element[],

    /**
     * Ein Wert, der die Sichtbarkeit der horizontalen ScrollBar festlegt.
     */
    HorizontalScrollBarVisibility?: ScrollBarVisibility,

    /**
     * Ein Wert, der die Sichtbarkeit der vertikalen ScrollBar festlegt.
     */
    VerticalScrollBarVisibility?: ScrollBarVisibility,

    /**
     * Inline-Style der dann gesetzt wird, wenn die ScrollBars nicht sichtbar sind.
     */
    style?: React.CSSProperties,

    /**
     * Inline-Style der dann gesetzt wird, wenn die ScrollBars sichtbar sind.
     */
    styleWhenNoScrollBar?: React.CSSProperties
}

interface IState
{
    /**
     * Ein Wert, der angibt, ob die vertikale ScrollBar sichtbar ist.
     */
    isVerticalScrollBarVisible?: boolean
}

export class ScrollViewer extends React.Component<IProperties, IState>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        HorizontalScrollBarVisibility: ScrollBarVisibility.visible,
        VerticalScrollBarVisibility: ScrollBarVisibility.visible
    };

    /**
     * Erstellt eine neue Instanz der Komponente @see ScrollViewer.
     * @param props Die Eigenschaften dieser Komponente.
     */
    constructor(props: IProperties)
    {
        super(props);
        this.state = {
            isVerticalScrollBarVisible: false
        };
    }

    /**
     * Wird bei jedem Rendern der Komponente ausgeführt und prüft ob die vertikale
     * ScrollBar sichtbar ist.
     * @param ref Das DOM-Element dieser Komponente.
     */
    private setRef = (ref: HTMLElement) =>
    {
        if (ref != null)
        {
            let isVerticalScrollBarVisible = ref.scrollHeight > ref.clientHeight || this.props.VerticalScrollBarVisibility === ScrollBarVisibility.visible;
            this.setState({
                isVerticalScrollBarVisible
            });
        }
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        var { HorizontalScrollBarVisibility, VerticalScrollBarVisibility, style, styleWhenNoScrollBar } = this.props;
        var { isVerticalScrollBarVisible } = this.state;
        var newStyle = null;

        if (isVerticalScrollBarVisible)
        {
            newStyle = {
                ...style,
                overflowX: HorizontalScrollBarVisibility,
                overflowY: VerticalScrollBarVisibility
            };
        }
        else
        {
            if (styleWhenNoScrollBar != null)
            {
                newStyle = {
                    ...styleWhenNoScrollBar,
                    overflowX: HorizontalScrollBarVisibility,
                    overflowY: VerticalScrollBarVisibility
                };
            }
            else
            {
                newStyle = {
                    ...style,
                    overflowX: HorizontalScrollBarVisibility,
                    overflowY: VerticalScrollBarVisibility
                };
            }
        }

        return (
            <div
                ref={ this.setRef}
                className="scrollviewer"
                style={newStyle}>
                {this.props.children}
            </div>
        );
    }
}